export enum InterceptorSkipHeader {
  Authorization = 'X-Skip-Header-Authorization',
  CustomHeader = 'X-Skip-Custom-Header',
}